import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../../Config/Config";

export const fetchCoachingData = createAsyncThunk("api/coaching", async () => {
  const response = await fetch(
    `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-coaching-institutes-list`
  );
  const data = await response.json();
  return data;
});

const coachingSlice = createSlice({
  name: "coaching",
  initialState: {
    coachingData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCoachingData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCoachingData.fulfilled, (state, action) => {
        state.loading = false;
        state.coachingData = action.payload;
      })
      .addCase(fetchCoachingData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default coachingSlice.reducer;
